<main class="fadeIn">
  <div class="container-fluid" #focusedElement>
    <div class="row">
      <div class="col-12">
        <div class="header d-flex justify-content-between">
          <h1><small></small>Role List</h1>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="filter-body">
          <div class="filter">
            <div class="row justify-content-between">
              <div class="col-10">
                <div class="row" [formGroup]="filterationForm">
                  <div class="col-3">
                    <label for="roleId" class="form-label">Role</label>
                    <input type="text" class="form-control " id="roleId" formControlName="role" appPreventFirstSpace>
                  </div>
                  <div class="col-3">
                    <label for="isActive-id" class="form-label">Status</label>
                    <app-select-dropdown id="isActive-id" [options]="statusOptions" label="label"
                      [placeholder]="'Select'" formControlName="isActive">
                    </app-select-dropdown>
                  </div>
                  <div class="col-2 d-flex align-items-end">
                    <button id="btnDrugFilterApply" type="button" class="btn btn-dark-blue"
                      (click)="filterApply()">APPLY</button>
                    <a class="reset-btn" (click)="resetFilter()"><span></span>Reset</a>
                  </div>
                </div>
              </div>
              <div class="col-2" *ngIf="checkPermission(rolePermission.addRole)">
                <label for="" class="form-label">&nbsp;</label>
                <button id="btnGroupAddNewUserList" type="button" data-bs-toggle="modal"
                  class="btn btn-primary float-end" (click)="isEdit=false;openAddEdit=true;">
                  Create New Role
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="table-container table-responsive">
          <table class="table table-list" *ngIf="!fetchingInProgress && roleList.length">
            <caption class="d-none">Manag users </caption>
            <thead>
              <tr>
                <th scope="col">Role Id
                  <span *ngIf="roleList?.length" class="sort-order" (click)="sortColumn('id')">
                    <a class="{{columnSort['id'].sortType}} "></a>
                  </span>
                </th>
                <th scope="col">Role Name
                  <span *ngIf="roleList?.length" class="sort-order" (click)="sortColumn('name')">
                    <a class="{{columnSort['name'].sortType}} "></a>
                  </span>
                </th>
                <th scope="col">Status <span class="sort-order"></span>
                </th>
                <th scope="col">Actions <span class="sort-order"></span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let role of roleList">
                <td>{{role.id| notEmpty : '-'}}</td>
                <td>{{role.name| notEmpty : '-'}}</td>
                <td>
                  <div class="status blue-circle-status" *ngIf="role?.isActive === 1"><span></span>Active</div>
                  <div class="status gray-circle-status" *ngIf="role?.isActive === 2"><span></span>Inactive</div>
                  <div *ngIf="role?.isActive === 1 && role?.isActive === 2">-</div>
                </td>

                <td>
                  <ul class="actions">
                    <li *ngIf="checkPermission(rolePermission.updateRole)" (click)="editRole(role)">
                      <a id="RuleCNEdit" data-bs-toggle="modal" class="edit-icon tool-wrap position-relative">
                        <div class="custom-tooltip tooltip-top" role="tooltip">
                          <div class="arrow"></div>
                          <div class="tooltip-inner"> Edit </div>
                        </div>
                      </a>
                    </li>
                    <li *ngIf="checkPermission(rolePermission.getRoleDetails)" (click)="viewRoleDetails(role)">
                      <a id="RuleCNView" data-bs-toggle="modal" class="view tool-wrap position-relative">
                        <div class="custom-tooltip tooltip-top" role="tooltip">
                          <div class="arrow"></div>
                          <div class="tooltip-inner"> View </div>
                        </div>
                      </a>
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="no-data with-border" *ngIf="!fetchingInProgress && !roleList.length">
            <img src="./assets/images/icons/no-data-img.svg" alt="">
            <p>No Results Found</p>
          </div>
        </div>
        <app-navigation [listLength]="totalCount" [pageNo]="page_no" (currentPageDetail)="currentPageDetail($event)">
        </app-navigation>
      </div>
    </div>
  </div>
</main>
<app-add-edit-role *ngIf="openAddEdit" [isEdit]="isEdit" [selectedItem]="selectedItem"
  (closeAddEdit)="closeAddEdit($event)"></app-add-edit-role>
<app-role-detail-view *ngIf="viewDetails" (closeDetails)="viewDetails=false;"
  [userTypeId]="selectedItem.id"></app-role-detail-view>